import { FC } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { RootState } from 'state/store';
import { selectLdTeamsById } from 'state/ProjectsList/include/ldTeamsSlice';
import { ProjectPrivacy } from 'utils/types/projectsList';
import { PROJECT_PRIVACY } from 'utils/constants/projectsList';

interface ProjectLDTeamsProps {
  teams: string[];
  privacy?: ProjectPrivacy;
}

const ProjectLDTeams: FC<ProjectLDTeamsProps> = ({
  teams,
  privacy = PROJECT_PRIVACY.PUBLIC,
}) => {
  const ldTeams = useSelector((state: RootState) =>
    selectLdTeamsById(state, teams)
  );

  if (privacy === PROJECT_PRIVACY.TEAM) {
    const teamNames = ldTeams.map((team) => team.name).join(', ');
    return <>{teamNames}</>;
  }

  if (privacy === PROJECT_PRIVACY.PRIVATE) {
    return <>{intl.get('PROJECT_DETAIL.PRIVACY_OPTIONS.PRIVATE')}</>;
  }

  return <>{intl.get('PROJECT_DETAIL.PRIVACY_OPTIONS.PUBLIC')}</>;
};

export default ProjectLDTeams;
